import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import React from 'react';
import styled from 'styled-components';
import THEME from '../../styles/colors';
import { IColorStyleProps } from '../../styles/css';
import Icon from '../Icon/Icon';
import StyledButton, { ButtonFill } from './StyledButton';

export const StyledPlusButton = styled(StyledButton)<IColorStyleProps>`
  padding: 0;
  outline: none;
  border: 1px solid ${({ $color }) => $color};
  border-radius: 50%;
  height: 40px;
  width: 40px;
  margin-right: 12px;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg,
  & svg * {
    fill: ${({ $color }) => $color};
  }
`;

interface IPlusButtonProps {
  onClick: Function;
  color: string;
}

const PlusButton: React.FC<IPlusButtonProps> = ({
  color = THEME.brand.maxpreps,
  ...rest
}) => (
  <StyledPlusButton $fillMode={ButtonFill.Outline} $color={color} {...rest}>
    <Icon icon={faPlus} size={16} color={color} />
  </StyledPlusButton>
);

export default PlusButton;
